import React, { Fragment } from 'react';

const Input = ({ label, ...rest }) => {
    return (
        <Fragment>
            <label>{label}</label>
            <input data-testid="components-input-filter" style={input} {...rest} />
        </Fragment>
    );
};

const input = {
    borderRadius: 0,
    fontSize: '12px',
};

export default Input;